uniform vec2 resolution;
uniform float time;
varying vec2 vUv;

#pragma glslify: snoise2 = require(glsl-noise/simplex/2d) 
#pragma glslify: snoise3 = require(glsl-noise/simplex/3d) 

vec4 makePatches(vec2 st, vec3 bottomColor, vec3 topColor, float breath, float smoothFactor) {

    float v = (snoise3(vec3(st * 0.002, time * 0.00009)) + 1.0) * 0.5;

    float contrast = 1.1;
    v = (v-0.5) * contrast + 0.5;
    
    float isHigh = step(0.5, v);

    vec3 finalColor = mix(bottomColor, topColor, isHigh);

    // Compute the adaptive smoothing factor using fwidth
    float edgeWidth = fwidth(v) * 0.5; // The multiplier can be adjusted for desired sharpness

    breath += edgeWidth;

    float isBelowLow = smoothstep(breath + smoothFactor, breath, v);

    float breathInverted = 1.0 - breath;
    float isAboutHigh = smoothstep(breathInverted - smoothFactor, breathInverted, v);

    float alpha = max(isBelowLow, isAboutHigh);

    return vec4(finalColor, alpha);
}

vec4 blendNormal(vec4 base, vec4 blend) {
    // Calculate the alpha of the output color
    float outAlpha = blend.a + base.a * (1.0 - blend.a);

    // Blend the colors
    vec3 outColor = (blend.rgb * blend.a + base.rgb * base.a * (1.0 - blend.a)) / outAlpha;

    return vec4(outColor, outAlpha);
}

vec4 applyPatchLayer(vec2 st, vec4 base, vec3 aColor, vec3 bColor, float timeOffset) {

    float breadth = 0.15 + ((sin(timeOffset + time * 0.001) * 0.5 + 0.2) * 0.1);
    vec4 patchLayer = makePatches(
        st * 2.0,
        aColor,
        bColor,
        breadth,
        0.005
    );
    return blendNormal(base, patchLayer);
}

vec2 getOffset (float seedX, float seedY) {
    float speed = 0.0001;
    float x = snoise2(vec2(seedX * 10., time * speed));
    float y = snoise2(vec2(seedY* 10., time * speed));
    vec2 offset = vec2(seedX + x, + seedY + y) * 100.0;
    return offset;
}

void main() {

    vec2 uv = vUv;
    uv -= 0.5;
    vec2 st = uv * resolution;
    // st.y += time * 0.05;

    gl_FragColor = vec4(vec3(0.95), 1.0);

    gl_FragColor = applyPatchLayer(
        st + getOffset(91.234123, 23.618), // + vec2(1890.0, 112335.0) + vec2(-time * 0.03),
        gl_FragColor,
        vec3(0.10,0.11,0.12),
        vec3(0.33,0.10,0.08),
        123.0
    );

    gl_FragColor = applyPatchLayer(
        st + getOffset(7.29, 2.1234), // + vec2(time * 0.05),
        gl_FragColor,
        vec3(0.99,0.65,0.41),
        vec3(0.24,0.34,0.37),
        17613.0
    );

    gl_FragColor = applyPatchLayer(
        st + getOffset(5.2874, 1.032), // + vec2(450.0, 1235.0) + vec2(time * 0.05, 0.0),
        gl_FragColor,
        vec3(0.82,0.85,0.83),
        vec3(0.86,0.79,0.69),
        9873.0
    );

}